import React, { Fragment } from 'react';
import { CTMVoucherForm, CTMVoucherResult, CTMModal } from '~/components';
import { connect } from 'react-redux';
import { sso2Lightning } from '~/redux/sso';
import { toggleAsideMenu } from '~/redux/application';
import { TripType, getProfileToken, getError, getTripType, animate, ThemeType, ErrorCode, config, DownloadVoucherStatus } from '~/common';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import BaseWidget from '../../components/BaseWidget';
import { Breadcrumb, Button, message, Modal, Table } from 'antd';
import { store } from '~/index.js';
import { searchTravelerSummary, SearchVoucher, DownloadVoucher, DownloadVouchersZip, RequestDownloadVoucher, SearchDownloadVoucher, ApplyVouchers } from '~/client';
import { prepareMeta, formatDate, convertDate } from '../PreTrip/helpers';
import moment from 'moment';
import ApplyVoucherInvoicePanel from '~/components/ApplyVoucherInvoicePanel';


class CTMVoucher extends React.Component {
    constructor(props) {
        super()
        this.state = {
            searchParam: {
                travelDateFrom: formatDate(moment().add(-3, 'months')),
                travelDateTo: '',
                travelerProfileSourceIds: [],
                voucherNo: '',
                companyId: null,
                pageSize: config.invoicePageSize,
                pageIndex: 1,
                profileToken: getProfileToken(),
                companyName: '',
                travelerId: '',
                travelerName: '',
                isTravelDate: true
            },
            dataSource: [

            ],
            travelDateTo: '',
            companyDataSource: [],
            travelDataSource: [],
            count: 0,
            searchLoading: false,
            customerCode: '',
            downloadVoucherNo: [],
            isModelVisable: false,
            downloadVoucherParam: {},
            activeTab: 'vouchers',
            bgDownloadVouchers: [],
            searchDownloadVoucherLoading: false,
            applyModalVisible: false,
            applyLoading: false,
        }
    }

    componentWillMount() {
        if (this.props.location && this.props.location.state) {
            this.handleSearchParamChange(this.props.location.state);
        }
        let companyDataSource = store.getState().user.viewCompanies;
        this.setState({ companyDataSource: companyDataSource })
        this.mounted = true;
    }
    componentWillUnmount() {
        this.mounted = false;
        window.clearTimeout(this.searchDownloadVoucherTimeoutId);
    }
    componentDidMount() {
        this.mounted = true;
        if (this.props.location && this.props.location.state) {
            this.handleSearchParamChange(this.props.location.state);
            this.handleSubmit('', this.props.location.state);
        }
    }
    fm = (id, values) => this.props.intl.formatMessage({ id }, values);

    handleSearch = (val, id) => {
        const params = {
            SearchKeyword: val,
            companyId: id,
            profileToken: getProfileToken(),
            TravelerIdType: 'ProfileSourceId',
            includeDummy: true,
            IgnoreUserDummyRestrictions: true,
            PageInfo: {
                PageIndex: this.state.pageIndex,
                PageSize: this.state.pageSize
            }

        };
        searchTravelerSummary(params, (_, rs) => {
            if (!this.mounted) return;
            let dataSource = [];
            if (rs && rs.summaryInfos && rs.summaryInfos.length > 0) {
                dataSource = rs.summaryInfos.map(({ code, displayName }) => ({ travelerId: code, travelerName: displayName }));
            }
            this.setState({ travelDataSource: dataSource, searchLoading: false });
        });
    }

    handleConfirmDownload = () => {
        if (this.props.enableDownloadVoucherAsync) {
            this.handleConfirmDownloadAsync();
            return;
        }
        var param = this.state.downloadVoucherParam
        this.setState({ isModelVisable: false });
        const tid = setTimeout(() => {
            this.setState({ searchLoading: false })
        }, 3000)
        DownloadVouchersZip(param, (_, rs) => {
            if (!this.mounted) return;
            window.clearTimeout(tid);
            if (rs != null) {
                if (rs.msg) {
                    message.warn(rs.msg);
                } else {
                    const link = document.createElement('a');
                    link.style.display = 'none';
                    link.href = URL.createObjectURL(rs);
                    link.download = 'Voucher-' + moment().format('YYYYMMDDhhmmss') + '.zip';
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                    URL.revokeObjectURL(link.href)
                }

            }
            this.setState({ searchLoading: false, downloadVoucherNo: [], downloadVoucherParam: {} })
        })
    }


    handleDownload = (val) => {
        if (this.props.enableDownloadVoucherAsync) {
            this.handleDownloadAsync(val);
            return;
        }
        var param = {
            VoucherNo: val.VoucherNo,
            CustomerCode: val.CustomerCode,
            FollowupCompany: val.FollowupCompany,
            profileToken: getProfileToken(),
        };
        if (this.state.downloadVoucherNo.length > 0 && !this.state.downloadVoucherNo.includes(val.VoucherNo)) {
            return
        }
        this.setState({ searchLoading: true })
        if (this.state.downloadVoucherNo.length > 1) {
            let paramList = { profileToken: param.profileToken, DownloadVouchers: [] };
            this.state.downloadVoucherNo.forEach(inv => {
                paramList.DownloadVouchers.push({ VoucherNo: inv, CustomerCode: param.CustomerCode, FollowupCompany: param.FollowupCompany })
            })
            this.setState({ isModelVisable: true, downloadVoucherParam: paramList })
        } else {

            if (this.state.downloadVoucherNo.length == 1) {
                param.VoucherNo = this.state.downloadVoucherNo[0];
            }
            const tid = setTimeout(() => {
                this.setState({ searchLoading: false })
            }, 3000)
            DownloadVoucher(param, (_, rs) => {
                if (!this.mounted) return;
                window.clearTimeout(tid);
                if (rs != null) {
                    if (rs.msg) {
                        message.warn(rs.msg);
                    } else {
                        message.warn(this.fm('downloading'));
                        // const link = document.createElement('a');
                        // link.style.display = 'none';
                        // link.href = URL.createObjectURL(rs);
                        // link.download = param.VoucherNo + '.pdf';
                        // document.body.appendChild(link)
                        // link.click()
                        // document.body.removeChild(link)
                        // URL.revokeObjectURL(link.href)
                    }

                }
                this.setState({ searchLoading: false, downloadVoucherNo: [] })
            })
        }
    }

    handleConfirmDownloadAsync = () => {
        var param = this.state.downloadVoucherParam
        this.setState({ isModelVisable: false });
        const tid = window.setTimeout(() => {
            this.setState({ searchLoading: false })
        }, 3000)
        RequestDownloadVoucher(param, (_, rs) => {
            if (!this.mounted) return;
            window.clearTimeout(tid);
            this.setState({ searchLoading: false })
            const errMsg = getError(rs);
            if (errMsg) {
                CTMModal.error({
                    className: 'ctm-modal-no-close-icon',
                    centered: true,
                    content: errMsg,
                });
                return;
            }
            this.setState({ downloadVoucherNo: [], downloadVoucherParam: {}, activeTab: 'background_downloads' });
            this.handleSearchDownloadVoucher();
        });
    }

    handleDownloadAsync = (val) => {
        var param = {
            VoucherNo: val.VoucherNo,
            CustomerCode: val.CustomerCode,
            FollowupCompany: val.FollowupCompany,
            profileToken: getProfileToken(),
        };
        let downloadVoucherNo = this.state.downloadVoucherNo;
        if (downloadVoucherNo.length > 0 && !downloadVoucherNo.includes(val.VoucherNo)) {
            return
        }
        if (downloadVoucherNo.length == 0) {
            downloadVoucherNo = [val.VoucherNo];
        }
        this.setState({ searchLoading: true })
        let paramList = { profileToken: param.profileToken, DownloadVouchers: [] };
        downloadVoucherNo.forEach(inv => {
            paramList.DownloadVouchers.push({ VoucherNo: inv, CustomerCode: param.CustomerCode, FollowupCompany: param.FollowupCompany })
        })
        this.setState({ isModelVisable: downloadVoucherNo.length > 1, downloadVoucherParam: paramList })
        if (downloadVoucherNo.length == 1) {
            window.setTimeout(() => this.handleConfirmDownload(), 300);
        }
    }

    handleSearchDateTo = (param) => {
        this.setState({ travelDateTo: param })
    }
    handleClearTraveler = () => {
        this.setState({ travelDataSource: [] })
    }
    handleSearchParamChange = (param) => {
        this.setState({ searchParam: param });
    }
    handleSubmit = (e, parParam, pageIndex = 1) => {
        e && e.preventDefault();
        if (!parParam) {
            parParam = this.state.searchParam;
            const { searchParam } = this.state;
            searchParam.pageIndex = pageIndex;
            this.setState({ searchParam: searchParam })
        }
        let searchParams = {
            issueDateFrom: "",
            issueDateTo: "",
            travelDateFrom: "",
            travelDateTo: "",
            travelerProfileSourceIds: parParam.travelerProfileSourceIds,
            voucherNo: parParam.voucherNo,
            pageSize: parParam.pageSize,
            pageIndex: parParam.pageIndex,
            profileToken: parParam.profileToken,
            companyId: parParam.companyId
        };
        if (parParam.isTravelDate) {
            searchParams.travelDateFrom = parParam.travelDateFrom;
            searchParams.travelDateTo = parParam.travelDateTo;
        } else {
            searchParams.issueDateFrom = parParam.travelDateFrom;
            searchParams.issueDateTo = parParam.travelDateTo;
        }
        if (!searchParams.companyId) {
            for (let inputParent of [...document.getElementsByClassName('cN')]) {
                let inputRequire = inputParent.getElementsByTagName('input')[0];
                inputRequire.click();
            }
        } else {
            if (this.props.isWidgets) {
                this.props.history.push('/vouchers', this.state.searchParam);
                return;
            }
            setTimeout(() => {
                this.setState({ searchLoading: true })
            })
            if (searchParams.travelDateTo) {
                searchParams.travelDateTo = formatDate(convertDate(searchParams.travelDateTo).add(+1, 'days'))
            }
            if (searchParams.issueDateTo) {
                searchParams.issueDateTo = formatDate(convertDate(searchParams.issueDateTo).add(+1, 'days'))
            }
            SearchVoucher(searchParams, (_, rs) => {
                if (!this.mounted) return;
                let data = [];
                if (rs && rs.Documents) {
                    rs.Documents.map((x, i) => {
                        let temp = x;
                        temp.key = i + 1;
                        data.push(temp)

                    })
                    this.setState({ dataSource: data, count: rs.RecordCount, searchLoading: false, downloadVoucherNo: [] })
                } else {
                    this.setState({ dataSource: [], count: 0, searchLoading: false, downloadVoucherNo: [] })
                }
            })
        }
    }

    handleDownloadVch = (param) => {
        this.setState({ downloadVoucherNo: param });
    }

    handleSearchDownloadVoucher() {
        if (this.state.searchDownloadVoucherLoading) return;
        var param = {
            profileToken: getProfileToken(),
        };
        this.setState({ searchDownloadVoucherLoading: true });
        window.clearTimeout(this.searchDownloadVoucherTimeoutId);
        SearchDownloadVoucher(param, (_, rs) => {
            if (!this.mounted) return;
            this.setState({ bgDownloadVouchers: rs.DownloadVouchers, searchDownloadVoucherLoading: false });
            if ((rs.DownloadVouchers || []).some(v => [DownloadVoucherStatus.Pending, DownloadVoucherStatus.Processing].includes(v.Status))) {
                this.searchDownloadVoucherTimeoutId = window.setTimeout(() => this.handleSearchDownloadVoucher(), 5000);
            }
        })
    }

    handleOpenApplyModal = () => {
        this.setState({ applyModalVisible: true });
    }

    handleCloseApplyModal = () => {
        this.setState({ applyModalVisible: false, applyLoading: false });
    }

    handleApplyVouchers = (selectedInvoices) => {
        const param = {
            profileToken: getProfileToken(),
            Vouchers: (selectedInvoices || []).map(v => ({
                InvoiceNo: v.InvoiceNo,
                CustomerCode: v.CustomerCode,
                FollowupCompany: v.FollowupCompany,
            })),
        };
        if (!param.Vouchers.length) {
            message.warn(this.fm('please_select_invoice_apply'));
            return;
        }

        this.setState({ applyLoading: true });
        ApplyVouchers(param, (err, rs) => {
            if (!this.mounted) return;
            this.setState({ applyLoading: false });
            if (err) {
                message.error(this.fm('apply_vouchers_failed'));
                return;
            }
            const errMsg = getError(rs);
            if (errMsg) {
                message.error(this.fm('apply_vouchers_failed'));
                CTMModal.error({
                    className: 'ctm-modal-no-close-icon',
                    centered: true,
                    content: errMsg,
                });
                return;
            }
            message.success(this.fm('apply_vouchers_success'));
            this.setState({ applyModalVisible: false });
            this.state.searchParam.companyId && this.handleSubmit(null, this.state.searchParam, this.state.searchParam.pageIndex);
        });
    }

    handleDownloadVoucher(item) {
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = item.FileUrl;
        link.download = item.FileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    render() {
        const { searchParam, dataSource, count, companyDataSource, travelDataSource, searchLoading, downloadVoucherNo, activeTab, bgDownloadVouchers, searchDownloadVoucherLoading, applyModalVisible, applyLoading } = this.state;
        const { enableDownloadVoucherAsync } = this.props;
        return (
            <Fragment>
                {!this.props.isWidgets && <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Breadcrumb className='breadcrumb'>
                        <Breadcrumb.Item className='breadcrumb-item'><FormattedMessage id='vouchers' /></Breadcrumb.Item>
                    </Breadcrumb>
                    {enableDownloadVoucherAsync && <div className='inv-tabs-dv'>
                        <button className={`inv-tab${activeTab == 'vouchers' ? ' active' : ''}`} onClick={() => this.setState({ activeTab: 'vouchers' })}>{this.fm('vouchers')}</button>
                        <button className={`inv-tab${activeTab == 'background_downloads' ? ' active' : ''}`} onClick={() => {
                            this.setState({ activeTab: 'background_downloads' });
                            this.handleSearchDownloadVoucher();
                        }}>{this.fm('background_downloads')}</button>
                    </div>}
                </div>}


                {activeTab == 'vouchers' && <div className='fare-forecaster test trips-container invFrom'>

                    <CTMVoucherForm
                        searchParam={searchParam}
                        handleSearchParamChange={this.handleSearchParamChange}
                        handleSubmit={this.handleSubmit}
                        intl={this.props.intl}
                        handleSearch={this.handleSearch}
                        companyDataSource={companyDataSource}
                        travelDataSource={travelDataSource}
                        handleClearTraveler={this.handleClearTraveler}
                        handleSearchDateTo={this.handleSearchDateTo}
                        onApply={this.handleOpenApplyModal}
                        isWidgets={this.props.isWidgets}></CTMVoucherForm>
                    {!this.props.isWidgets && <CTMVoucherResult
                        dataSource={dataSource}
                        count={count}
                        searchParam={searchParam}
                        handleSearchParamChange={this.handleSearchParamChange}
                        handleSubmit={this.handleSubmit}
                        intl={this.props.intl}
                        handleDownload={this.handleDownload}
                        searchLoading={searchLoading}
                        downloadVoucherNo={downloadVoucherNo}
                        handleDownloadInv={this.handleDownloadVch}
                    ></CTMVoucherResult>}
                </div>}

                {activeTab == 'background_downloads' && <div className='inv-downloads trips-container'>
                    <div className='caption'>{this.fm('background_downloads')}</div>
                    <div className='hint'>{this.fm('background_downloads_tips_vouchers')}</div>
                    <Table dataSource={bgDownloadVouchers}
                        columns={[
                            {
                                title: this.fm('requested_at'),
                                dataIndex: 'RequestedAt',
                            },
                            {
                                title: this.fm('total_vouchers'),
                                dataIndex: 'TotalVouchers',
                            },
                            {
                                title: this.fm('status'),
                                dataIndex: 'StatusRemark',
                                render: (_, record) => {
                                    return <div className={`badge status-${record.Status}`}>{record.StatusRemark}</div>;
                                }
                            },
                            {
                                title: this.fm('estimated_time_remaining'),
                                dataIndex: 'EstimatedTimeRemaining',
                                render: (_, record) => {
                                    return <div>{record.EstimatedTimeRemaining > 0 ? `${record.EstimatedTimeRemaining}s` : '——'}</div>;
                                }
                            },
                            {
                                title: this.fm('expire_date'),
                                dataIndex: 'ExpireDate',
                            },
                            {
                                title: this.fm('actions'),
                                align: 'right',
                                render: (_, record) => {
                                    return <div>{record.FileUrl ? <button className='ctm-btn ctm-tile-btn ctm-btn-xs' onClick={() => this.handleDownloadVoucher(record)}>{this.fm('download')}</button> : record.Status == DownloadVoucherStatus.Failed ? <></> : <button className='ctm-btn ctm-tile-btn ctm-btn-xs' disabled='disabled'>{this.fm('preparing')}...</button>}</div>;
                                }
                            }
                        ]}
                        pagination={false}
                        rowKey={'Id'}
                        loading={!(bgDownloadVouchers || []).length && searchDownloadVoucherLoading}
                    />

                </div>}

                <Modal
                    title={<FormattedMessage id='download_pdf' />}
                    visible={this.state.isModelVisable}
                    closable={false}
                    centered={true}
                    destroyOnClose={true}
                    footer={[
                        <Button key="back" onClick={() => { this.setState({ isModelVisable: false, searchLoading: false, downloadVoucherParam: {} }) }}>
                            <FormattedMessage id='cancel'></FormattedMessage>
                        </Button>,
                        <Button key="submit" type="primary" onClick={() => this.handleConfirmDownload()}>
                            <FormattedMessage id='ok'></FormattedMessage>
                        </Button>,
                    ]}
                >
                    <p><FormattedMessage id='batch_donwnload_zip' /></p>
                </Modal>

                <Modal
                    title={<FormattedMessage id='apply_vouchers' />}
                    visible={applyModalVisible}
                    closable={true}
                    centered={true}
                    destroyOnClose={true}
                    onCancel={this.handleCloseApplyModal}
                    footer={null}
                    width={1200}
                >
                    <ApplyVoucherInvoicePanel
                        companyDataSource={companyDataSource}
                        applying={applyLoading}
                        onApply={this.handleApplyVouchers}
                    />
                </Modal>
            </Fragment>

        )
    }
}

export default connect(state => ({
    isLightMode: state.userSetting.ThemeType === ThemeType.Breezy,
    defaultDepartureCity: state.userData.DefaultDepartureCity,
    searchTimeoutMinutes: state.application.sessionTimeoutMinutes,
    enableDownloadVoucherAsync: state.user.enableDownloadVoucherAsync,
}), dispatch => ({
    sso2Lightning: payload => dispatch(sso2Lightning(payload)),
    toggleAsideMenu: payload => dispatch(toggleAsideMenu(payload)),
}))(injectIntl(withRouter(BaseWidget(CTMVoucher))));
